import { useQuery } from "react-query";
import {
    ParamsGetPelanggan,
    GetPelangganResponse,
} from "../../constants/types";
import axios from "../axios";
import qs from "query-string";

const handleRequest = async (params: ParamsGetPelanggan) => {
    const apiGetPelanggan = qs.stringifyUrl({
        url: "api/pelanggans",
        query: {
            warehouseId: params.warehouseId,
            search: params.search,
            size: params.size,
            page: params.page,
        },
    });
    const { data } = await axios.get<GetPelangganResponse>(apiGetPelanggan);
    return data.data;
};

export default function usePelanggan(params: ParamsGetPelanggan) {
    return useQuery<GetPelangganResponse["data"]>(["pelanggan", params], () =>
        handleRequest(params),
    );
}
